import { injectGlobal } from 'styled-components'
import { Grid, Cell } from "styled-css-grid";
import { normalize } from 'styled-normalize'

injectGlobal`
  ${normalize}
`



// WEBPACK FOOTER //
// ./src/styles/global-styles.js